/* eslint-disable simple-import-sort/imports */
import {
  Button,
  DialogActions,
  TextareaAutosize,
  IconButton,
  Typography,
  Snackbar,
  Alert,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import { useUserFeedback } from 'queries/Users';
import { getLocalStorageItem } from 'hooks';

const FeedbackModal = ({ open, handleClose }: any) => {
  const { mutate: UserAddFeedback } = useUserFeedback();
  const UserDetails = getLocalStorageItem('roles');
  const pageLocation = window.location.href;

  const [message, setMessage] = useState('');
  const captureRef = useRef<HTMLDivElement>(null);
  const [screenshot, setScreenshot] = useState<File | null>(null);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>(
    'success'
  );

  const showSnackbar = (msg: string, severity: 'success' | 'error') => {
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const captureScreen = async () => {
    if (captureRef.current) {
      // const canvas = await html2canvas(captureRef.current);
      const canvas = await html2canvas(document.body, {
        useCORS: true, // Ensures cross-origin images are included
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        scrollX: 0,
        scrollY: 0,
      });
      canvas.toBlob((blob) => {
        if (!blob) return;

        const file = new File([blob], `${Date.now()}_screenshot.png`, {
          type: 'image/png',
        });
        setScreenshot(file); // Save screenshot in state
        console.log('Screenshot captured:', file);
        showSnackbar('ScreenShot captured successfully!', 'success');
      }, 'image/png');
      // const image = canvas.toDataURL('image/png');
      // const link = document.createElement('a');
      // link.href = image;
      // link.download = `${Date.now()}_screenshot.png`;
      // link.click();
    }
  };

  const closeDialog = () => {
    setMessage('');
    handleClose();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSubmit = () => {
    UserAddFeedback(
      {
        message,
        userId: UserDetails.id,
        file: screenshot,
        pageLocation,
      },
      {
        onSuccess: () => {
          showSnackbar('Feedback submit successfully!', 'success');
          setTimeout(() => {
            closeDialog();
          }, 2000);
        },
        onError: (error: any) => {
          showSnackbar(
            `Error: ${error?.message || 'Failed to create feedback'}`,
            'error'
          );
        },
      }
    );
  };

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {open && (
        <section className="fixed left-0 top-0 z-40 flex h-[100vh] w-full justify-end overflow-hidden bg-[#0000000d]">
          <article className="flex w-[400px] flex-col overflow-auto rounded-xl rounded-r-none bg-white px-6 py-2 shadow-md">
            <div className="self-end">
              <IconButton
                aria-label="Close"
                onClick={closeDialog}
                className="text-black"
              >
                <CloseIcon />
              </IconButton>
            </div>
            {/* Header Section */}
            <div ref={captureRef} style={{ background: '#fff' }}>
              <div className="flex flex-col gap-6">
                <div className="flex justify-between">
                  <div>
                    <Typography variant="h6" className="font-bold">
                      Feedback
                    </Typography>
                  </div>
                </div>

                {/* Form Section */}
                <TextareaAutosize
                  className="focus:outline-none"
                  minRows={8}
                  placeholder="Enter your feedback..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  style={{ width: '100%', padding: '10px', fontSize: '16px' }}
                />
              </div>
              <DialogActions className="flex justify-between">
                <Button
                  type="button"
                  onClick={captureScreen}
                  variant="contained"
                  className="border border-[#11AC9E]"
                  style={{ border: '1px solid #11AC9E' }}
                  color="primary"
                  sx={{
                    border: '#90BEE6',
                    backgroundColor: 'transparent',
                    color: '#000',
                    '&:hover': {
                      backgroundColor: '#90BEE6', // Darker shade for hover effect
                      color: '#fff',
                    },
                  }}
                >
                  Capture Screen
                </Button>
                <Button
                  type="button"
                  onClick={handleSubmit}
                  color="secondary"
                  sx={{
                    background: '#11AC9E',
                    '&:hover': {
                      backgroundColor: '#90BEE6', // Darker shade for hover effect
                    },
                  }}
                >
                  Send
                </Button>
              </DialogActions>
            </div>
          </article>
        </section>
      )}
    </>
  );
};

export default FeedbackModal;
